define(function(require) {
    var IpsModel = require('civicsBase/ipsModel');
    return IpsModel.extend({
      urlRoot: '/delegate/civics-api/api/portal/authorizeduser/invitations/token',
      url: function(){
        var url = this.urlRoot;
        if (this.invitationToken && this.invitationToken.length > 1) {
          // url += '/' + this.id;
          url += '/' + "?InvitationToken=" + this.encodeComponent(this.invitationToken);
      }
  
        return url;
      },
    });
  });
  